import { useParams } from "react-router-dom";
import { BlogDetailsCubit, IBlogDetailsCubit } from "../blocs/blog/BlogDetailsBloc";
import { BlogDetailsBody } from "./BlogDetailsBody";


export default function BlogDetailsPage() {
    const { id } = useParams();
    const blogDetailsCubit:IBlogDetailsCubit = new BlogDetailsCubit(id!);
    return <BlogDetailsBody cubit={blogDetailsCubit} />;
}